import { SelectedFilters } from '@/components/FilterData/types';
import { getApiError } from '@/types/apiError';
import { useQuery } from '@tanstack/react-query';
import { queryFunction, queryKey } from './query';
import { UUID } from '@/api/generatedApi';

export const useAssetCompositeSearch = ({
  assetId,
  tenantId,
  searchQuery,
  selectedFilters,
  page,
  perPage,
  enabled = true,
}: {
  assetId: UUID;
  tenantId: UUID;
  searchQuery?: string;
  selectedFilters?: SelectedFilters;
  page?: number;
  perPage?: number;
  enabled?: boolean;
}) => {
  const { data, isLoading, error } = useQuery({
    queryKey: queryKey({
      assetId,
      tenantId,
      searchQuery,
      selectedFilters,
      page,
      perPage,
    }),
    queryFn: queryFunction({
      assetId,
      tenantId,
      searchQuery,
      selectedFilters,
      page,
      perPage,
    }),
    enabled: enabled && !!assetId && !!tenantId,
  });

  return { data: data?.data, isLoading, error: getApiError(error) };
};
